module.exports = __webpack_public_path__ + "img/s3-alert.6a652ca4.svg";